import React, { useCallback, useLayoutEffect, useState } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import PopOutInfo from '../PopOutInfo/PopOutInfo';
import HeroVideo from '../HeroVideo/HeroVideo';
import SeoHead from '../SeoHead/SeoHead';
import { useLocation } from 'react-router-dom';
import { getImageUrl } from '../../utils/imageUtils';
import { DEFAULT_DESCRIPTION } from '../../seo/siteSeo';

function heroImageForPath(pathname, configuration) {
  let key = null;
  if (pathname.startsWith('/dienstleistungen')) key = 'servicesImage';
  else if (pathname.startsWith('/galerie')) key = 'galleryImage';
  else if (pathname.startsWith('/online-termin')) key = 'appointmentImage';
  else if (pathname.startsWith('/impressum')) key = 'impressumImage';
  else if (pathname.startsWith('/datenschutz')) key = 'dataProtectionImage';
  if (!key || !configuration[key]) return null;
  return getImageUrl(configuration[key], 'large') || getImageUrl(configuration[key], 'original') || null;
}

export default function PageLayout({
  configuration = {},
  title,
  helmetTitle,
  description,
  path,
  jsonLd,
  includeLocalBusiness = false,
  children,
  intro = false,
  compact = true,
  hero = true,
}) {
  const location = useLocation();
  const playIntro = Boolean(intro && !compact);
  const [introActive, setIntroActive] = useState(playIntro);
  const endIntro = useCallback(() => setIntroActive(false), []);
  const lines = configuration.homeWriter
    ? String(configuration.homeWriter).split(',').map((line) => line.trim()).filter(Boolean)
    : ['stop+go Partner.', 'VAG-Kompetenz.', 'Fair in Davos.'];
  const heroImage = heroImageForPath(location.pathname, configuration);
  const seoPath = path || location.pathname || '/';

  useLayoutEffect(() => {
    document.body.classList.toggle('spg-intro-active', introActive);
    if (introActive) {
      return () => document.body.classList.remove('spg-intro-active');
    }
    const timer = window.setTimeout(() => {
      window.dispatchEvent(new Event('spg-page-ready'));
    }, playIntro ? 400 : 0);
    return () => {
      window.clearTimeout(timer);
      document.body.classList.remove('spg-intro-active');
    };
  }, [introActive, playIntro]);

  return (
    <div className={`spg-shell${hero ? '' : ' is-no-hero'}${introActive ? ' is-intro' : ''}`}>
      <SeoHead
        title={helmetTitle || `Sportplatzgarage Gutknecht – ${title} | Davos`}
        description={description || DEFAULT_DESCRIPTION}
        path={seoPath}
        jsonLd={jsonLd}
        includeLocalBusiness={includeLocalBusiness}
      />
      {introActive ? null : (
        <PopOutInfo
          openingHours={configuration.openingHours}
          mapsLink={configuration.mapsLink}
          mapsLinkText={configuration.mapsLinkText}
          popUpcontactText={configuration.popUpcontactText}
        />
      )}
      <Header
        color="transparent"
        fixed
        currentLocation={location.pathname}
        hasHero={hero}
      />
      {hero ? (
        <HeroVideo
          src={configuration.heroVideoUrl}
          image={heroImage}
          title="Sportplatzgarage Gutknecht"
          pageTitle={title}
          lines={lines}
          intro={playIntro}
          compact={compact}
          onIntroEnd={endIntro}
        />
      ) : null}
      <main className="spg-main">{children}</main>
      <Footer footerText={configuration.footerText} partnerText={configuration.partnerText} />
    </div>
  );
}
